import { useEffect, useState } from 'react'

const sdbl_vm21 = require('../db/sdbl_vm21.json')

function textCleanup(l) {
  if (/^\d/.test(l)) l = l.slice(2)
  if (l.includes(';-')) l = l.slice(0, l.indexOf(';'))
  if (l.includes(')')) l = l.slice(0, l.indexOf(')') + 1)
  l = l.replace(';-', '')
  return l
}

function hasNumLabels(lyrics) {
  return lyrics.some(v => /^\d/.test(v[0][0]))
}

function verseLabel(verse, verse2, hasNum, index) {
  if (hasNum) {
    if (/^\d/.test(verse2[0][0])) return `Verse ${verse2[0][0]}`
    if (!verse[0].length) return 'Verse 99'
    return 'Chorus'
  }
  return `Verse ${index + 1}`
}

function LyricVerse({ verse, verse2, hasNum, index, languageToggle }) {
  const label = verseLabel(verse, verse2, hasNum, index)
  return (
    <div className="library-verse">
      <div className="fg-ac1 fs-6">{label}</div>
      {languageToggle.v && verse.map((l, i) => (
        <div key={i} className="fg-l1 fs-6">{textCleanup(l)}</div>
      ))}
      {languageToggle.v2 && verse2.map((l, i) => (
        <div key={i} className="fg-l2 fs-6">{textCleanup(l)}</div>
      ))}
    </div>
  )
}

function PanelRight({ selectedSong, languageToggle }) {
  const [song, setSong] = useState(null)

  useEffect(() => {
    if (selectedSong)
      setSong(sdbl_vm21.find(s => s.title === selectedSong) || null)
  }, [selectedSong])

  return (
    <div className="library-col library-col--main">
      {song && (
        <>
          <div className="library-song-header">
            <div className="fs-3 fg-ac1">{song.title}</div>
            <div className="fg-l2 fw-lighter fs-6">{song.title2}</div>
          </div>
          <div className="library-lyrics song-preview-lyrics">
            {song.lyrics2 && song.lyrics2.map((v, i) => (
              <LyricVerse
                key={i}
                verse2={song.lyrics2[i]}
                verse={song.lyrics[i]}
                hasNum={hasNumLabels(song.lyrics)}
                index={i}
                languageToggle={languageToggle}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default PanelRight
